
<div  class="container form my-5 w-50 py-5">
    
    <form (ngSubmit)="getLoginData (loginForm)"  [formGroup]="loginForm" class="w-75 mx-auto my-5">
    

        <div class="form-group my-5">
            <label>Email</label>
            <input [class.is-valid]="loginForm.get('email').status == 'VALID' " formControlName="email" type="email" class="form-control">
            <p  *ngIf="loginForm.get('email').errors != null && loginForm.get('email').touched" class="alert alert-danger">please enter valid Email</p>
        </div>
    
        <div class="form-group my-5">
            <label>password</label>
            <input [class.is-valid]="loginForm.get('password').status == 'VALID' " formControlName="password" type="password" class="form-control">          
            <p *ngIf="loginForm.get('password').errors != null && loginForm. get('password').touched" class="alert alert-danger">please enter valid  password</p>
        </div>
        
       <p>{{LoginError}}</p>
        
    
        
        <button [disabled]="loginForm.untouched || (loginForm.touched&& loginForm.status == 'INVALID')"  type="submit" class="btn btn-primary">Login</button>
    </form>
    </div> 